export default __webpack_public_path__ + "static/media/e5.d597c7b1.jpeg";